$( document ).ready(function() {
    var url = window.location.href;

    $('.c-timebar').slick({
        infinite: false,
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 3,
        nextArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--next"><svg class="o-icon o-icon__xxlarge"><use xlink:href="'+url+'#slider_right"></use></svg></button>',
        prevArrow: '<button type="button" class="o-sliderarrows o-sliderarrows--prev"><svg class="o-icon o-icon__xxlarge"><use xlink:href="'+url+'#slider_left"></use></svg></button>',
        speed: 900,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    centerMode: true,
                    slidesToShow: 1,
                    centerPadding: '50',
                }
            },
        ]
    });


    if(!$('.slick-slide').hasClass('.slick-current')) {
        //$('.c-timebar__description').css('opacity', 0);
    }

     $('.c-timebar').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.slick-current .c-timebar__description').css('opacity', 0);
         //$('.slick-current .c-timebar__image').removeClass('slick-done');

    });

    $('.c-timebar').on('afterChange', function(event, slick, currentSlide) {
        $('.c-timebar__description').css('opacity', 0);
        $('.slick-current .c-timebar__description').velocity(
            {
                opacity: 1,
            }
            )
            .velocity(
                "fadeIn",{
                    duration: 250,
                    delay: 0,
                }
            );
        //$('.slick-current .c-timebar__image').addClass('slick-done');
    });

});